import styled, { css } from 'styled-components';
import { space, typography } from 'styled-system';

import ButtonStyles from './buttonStyles';

const PanelStyles = styled.div`
  ${space}
  ${typography}

  border: 0.0625rem solid ${props => props.theme.colors.separator};
  box-shadow: ${props => props.theme.boxShadowPanel};
  background: ${props => props.theme.colors.white};

  ${ButtonStyles} {
    min-height: ${props => props.theme.buttonSize.normal};
  }

  ${props =>
    props.centered &&
    css`
      margin-left: auto;
      margin-right: auto;
    `};

  ${props =>
    props.p === undefined &&
    css`
      padding-top: ${props.theme.space[3]};
      padding-bottom: ${props.theme.space[3]};
      padding-left: ${props.theme.space[2]};
      padding-right: ${props.theme.space[2]};
    `};

  ${props =>
    props.maxWidth !== undefined &&
    css`
      max-width: ${props.maxWidth}px;
      width: 100%;
    `};

  ${props =>
    props.positioned !== undefined &&
    css`
      position: absolute;
    `};

  ${props =>
    props.bookLayout !== undefined &&
    css`
      padding-bottom: 50%;
      position: relative;
    `};

  ${props =>
    props.borderColor !== undefined &&
    css`
      position: relative;

      &::before {
        content: '';
        display: block;
        position: absolute;
        background-color: ${props.theme.colors[props.borderColor] ?? props.borderColor};
        top: -0.0625rem;
        left: -0.0625rem;
        right: -0.0625rem;
        height: 0.125rem;
      }
    `};
`;

const PanelLeftStyles = styled.div`
  background: orange;
  position: absolute;
  left: 0;
  top: 0;
  width: 50%;
  height: 100%;
`;
const PanelRightStyles = styled.div`
  background: lime;
  position: absolute;
  right: 0;
  top: 0;
  width: 50%;
  height: 100%;
`;

PanelStyles.LeftStyles = PanelLeftStyles;
PanelStyles.RightStyles = PanelRightStyles;

export default PanelStyles;
